export default __webpack_public_path__ + "static/media/BTC.6c2ee359.svg";